/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_7df3a136"]'><cube-divider :position="position" text="文本内容"/></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7df3a136"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7df3a136"}
  /** script content **/
  require("./divider-position.mpx.js?isComponent&outputPath=components%2Fdivider-position7df3a136%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./divider-position.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdivider-position7df3a136%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7df3a136"],
    ctorType: "component",
    outputPath: "components/divider-position7df3a136/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>